<template>
  <LazyHomeCommonLayout>
    <template #content>
      <main class="subPage">
        <div class="backBg"></div>
        <LazyHomeContentRequestDemo v-fade :is-dark-mode="false" />
        <LazyHomeContentCP v-fade class="sub" />
      </main>
    </template>
  </LazyHomeCommonLayout>
</template>

<script setup lang="ts">
import {
  LazyHomeContentRequestDemo,
  LazyHomeContentCP
} from "#components";
</script>
